<template>
  <div :class="['image-wrapper', wrapperClass, { overlay: showLoader, disabled: disabled }]">
    <loading-icon v-if="showLoader"></loading-icon>
    <div v-else class="image">
      <img :class="[imageRounding]" :src="previewUrl" alt="uploaded-image" @error="$emit('errorLoadingImage', 'error resizing image, please try again later')">
      <p v-if="showImageFooter" class="disclaimer-placeholder">regional disclaimer (if applicable)</p>
    </div>
  </div>
</template>

<script>
  import LoadingIcon from '../Shared/LoadingIcon'

  export default {
    props: {
      disabled: Boolean,
      loading: Boolean,
      imageLoading: Boolean,
      previewUrl: String,
      showImageFooter: Boolean,
      wrapperClass: String,
    },

    name: 'ImagePreview',

    components: {
      LoadingIcon
    },

    computed: {
      imageRounding: function () {
        return this.showImageFooter ? 'top-round' : 'rounded'
      },

      showLoader: function(){
        return (this.imageLoading || this.loading)
      }
    },

    watch: {
      imageLoading: function() {
        this.showLoader
      }
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.image-wrapper
  &.disabled
    cursor: not-allowed

.image
  border-radius: 28px

  img
    height: auto
    padding: 0
    width: 450px
    @media only screen and (max-width: 40em)
      width: 300px

.rounded
  border-radius: 28px

.top-round
   border-radius: 28px 28px 0px 0px
   
.final-preview
  border: 4px solid $primary-color
  border-radius: 32px
  margin: 1rem
  max-width: 700px
  padding: 0 0 .5rem 0
  width: 80%

  p
    font-size: 1rem
    margin-top: .5rem

  img
    height: auto
    width: 100%
</style>